module.exports = __webpack_public_path__ + "img/rows-01.ad89113c.svg";